import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { BRAND, OWNER, CITY, CONTACT_EMAIL, WHATSAPP_LINK } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white mt-24">
      <div className="container-app py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-block w-2 h-6 bg-gold" />
            <span className="font-display text-2xl text-white">
              Scholar<span className="text-gold">Print</span>Hub
            </span>
          </div>
          <p className="text-slate-300 text-sm max-w-md">
            From research idea to final hard-bound thesis, everything in one place.
            Academic support, editing, formatting, plagiarism checking, and printing — proudly from Lucknow, India.
          </p>
          <div className="mt-6 space-y-2 text-sm text-slate-300">
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> {CITY}</div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> {CONTACT_EMAIL}</div>
            <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-gold">
              <MessageCircle className="w-4 h-4 text-gold" /> WhatsApp us
            </a>
          </div>
        </div>

        <div>
          <div className="section-eyebrow text-gold mb-4">Services</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-gold" to="/services/thesis-writing">Thesis Writing</Link></li>
            <li><Link className="hover:text-gold" to="/services/synopsis-writing">Synopsis Writing</Link></li>
            <li><Link className="hover:text-gold" to="/services/research-paper">Research Paper</Link></li>
            <li><Link className="hover:text-gold" to="/services/plagiarism-check">Plagiarism Check</Link></li>
            <li><Link className="hover:text-gold" to="/services/formatting">Formatting</Link></li>
            <li><Link className="hover:text-gold" to="/services/printing-binding">Printing & Binding</Link></li>
          </ul>
        </div>

        <div>
          <div className="section-eyebrow text-gold mb-4">Tools</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-gold" to="/upload">Upload PDF</Link></li>
            <li><Link className="hover:text-gold" to="/calculator">Price Calculator</Link></li>
            <li><Link className="hover:text-gold" to="/track">Track Order</Link></li>
            <li><Link className="hover:text-gold" to="/academic-request">Academic Request</Link></li>
            <li><Link className="hover:text-gold" to="/about">About Us</Link></li>
            <li><Link className="hover:text-gold" to="/contact">Contact</Link></li>
            <li className="pt-2 border-t border-white/10 mt-3"><Link className="hover:text-gold text-slate-400" to="/lp/thesis-printing-lucknow">Thesis Printing Lucknow</Link></li>
            <li><Link className="hover:text-gold text-slate-400" to="/lp/hard-binding-online-india">Hard Binding Online India</Link></li>
            <li><Link className="hover:text-gold text-slate-400" to="/lp/thesis-writing-assistance-india">Thesis Writing Assistance India</Link></li>
            <li><Link className="hover:text-gold text-slate-400" to="/lp/synopsis-writing-service">Synopsis Writing Service</Link></li>
            <li className="pt-2 border-t border-white/10 mt-3"><Link className="hover:text-gold" to="/privacy">Privacy Policy</Link></li>
            <li><Link className="hover:text-gold" to="/terms">Terms & Conditions</Link></li>
            <li><Link className="hover:text-gold" to="/disclaimer">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-app py-4 text-xs text-slate-400 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© 2026 {BRAND}. Managed by {OWNER}. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>@surajdubeyks</span>
            <span className="hidden md:inline">·</span>
            <span>Made for students & researchers in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
